import './styles.css'

// register
import { App } from '../../../configs/FirebaseConfig'
import { ChangeEvent, useState } from 'react'
import {
	getAuth,
	signInWithEmailAndPassword,
	// signOut,
	// onAuthStateChanged
} from 'firebase/auth'
// store
import { collection, addDoc, getFirestore } from 'firebase/firestore'
// demo
import Navbar from './Navbar'
function Authentication() {
	const auth = getAuth(App)
	const database = getFirestore(App)
	const dbInstance = collection(database, 'users')

	const [signIn, setSignIn] = useState({
		email: '',
		password: ''
	})

	const [signUp, setSignUp] = useState({
		name: '',
		email: '',
		password: ''
	})

	const handleSignInInputs = (event: ChangeEvent<HTMLInputElement>) => {
		let inputs = { [event.target.name]: event.target.value }
		setSignIn({ ...signIn, ...inputs })
	}


	const onSignIn = () => {
		signInWithEmailAndPassword(auth, signIn.email, signIn.password)
			.then(() => {
				// đăng nhập thành công
				alert('đăng nhập thành công')
			})
			.catch(err => {
				// đăng nhập không thành công
				alert('đăng nhập thất bại')
			})
	}

	const handleSignUpInputs = (event: ChangeEvent<HTMLInputElement>) => {
		let inputs = { [event.target.name]: event.target.value }
		setSignUp({ ...signUp, ...inputs })
	}

	const onSignUp = () => {
		addDoc(dbInstance, signUp)
			.then(() => {
				alert('send data success')
			})
			.catch((err) => {
				console.error(err.message)
			})
	}

	//   const handlelogout = () => {
	//     signOut(auth)
	//   }

	return (
		<div>
			<nav><Navbar /></nav>
			<main className='container-md main-content component-main'>
				<div className='card text-bg-light mb-3' style={{width: '30%'}}>
					<h6 className='card-header'>Log in</h6>
					<div className='card-body'>
						{/* credentical */}
						<div className='component-sign-in component-show fs-root'>
							<div className='row m-2 align-items-center'>
								<label className='col-5'>tên đăng nhập:</label>
								<input placeholder='Email' name='email' type='email' className='col' onChange={event => handleSignInInputs(event)} />
							</div>
							<div className='row m-2 align-items-center'>
								<label className='col-5'>mật khẩu</label>
								<input placeholder='Password' name='password' type='password' className='col' onChange={event => handleSignInInputs(event)} />
							</div>
							<div className='d-flex flex-column align-items-center m-2'>
								{/* sign in */}
								<button onClick={onSignIn}>Sign In</button>
							</div>

						</div>
						<div className='component-sign-up component-hidden'>
							<input placeholder='Name' name='name' type='text'
								className='input-fields'
								onChange={event => handleSignUpInputs(event)}
							/>
							<input placeholder='Email' name='email' type='email'
								className='input-fields'
								onChange={event => handleSignUpInputs(event)}
							/>
							<input placeholder='Password' name='password' type='password'
								className='input-fields'
								onChange={event => handleSignUpInputs(event)}
							/>

							{/* sign up */}
							<button onClick={onSignUp}>Sign up</button>
						</div>
					</div>
				</div>
			</main>
		</div>
	)
}

export default Authentication
